
import { defineComponent } from "vue";
import { ISystemEvaluationMetricsModel } from "@/interfaces/modules";
import SystemEvaluationMetricsService from "@/api/Academic/SystemEvaluationMetricsService";
import store from "@/store";

export default defineComponent({
  name: "SystemEvaluationMetricsContent",
  data() {
    return {
      form: {
        dialog: false,
        record: {} as ISystemEvaluationMetricsModel,
      },
      table: {
        filters: {
          search: "",
        },
        currentPage: 1,
        loading: false,
        headers: [
          { key: "Code", label: "Código", sortable: true },
          { key: "Name", label: "Nombre", sortable: true },
          { key: "Description", label: "Descripción", sortable: true },
          { key: "MinValue", label: "Mínimo", sortable: true },
          { key: "MaxValue", label: "Máximo", sortable: true },
          { key: "Enable", label: "Activo", sortable: true },
          { key: "CreatedByFormat", label: "Creación", sortable: true },
          { key: "ModifiedByFormat", label: "Última modificación", sortable: true },
          { key: "action", label: "Acciones", sortable: false },
        ],
        records: [] as ISystemEvaluationMetricsModel[],
        rowsPerPage: 10,
      },
    };
  },
  computed: {
    filteredItems(): ISystemEvaluationMetricsModel[] {
      const search = this.table.filters.search.toLowerCase();
      return this.table.filters.search
        ? this.table.records.filter(
            (item) =>
              item.Name?.toLowerCase().includes(search) ||
              item.Code?.toLowerCase().includes(search) ||
              item.Description?.toLowerCase().includes(search)
          )
        : this.table.records;
    },
    rows(): number {
      return this.table.records.length;
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.table.loading = true;
      this.table.records = await SystemEvaluationMetricsService.GetEvaluationMetrics();
      this.table.loading = false;
    },
    async edit(item: ISystemEvaluationMetricsModel) {
      this.form.record = await SystemEvaluationMetricsService.GetEvaluationMetricById(item);
      this.form.dialog = true;
    },
    openModal() {
      this.form.record = {
        Code: "",
        Name: "",
        Description: "",
        MinValue: 0,
        MaxValue: 0,
        Enable: true,
      } as ISystemEvaluationMetricsModel;
      this.form.dialog = true;
    },
    async handleSubmit() {
      this.form.dialog = false;
      await SystemEvaluationMetricsService.PostEvaluationMetric(this.form.record);
      store.dispatch("core/popupDialog", {
        text: "Registro guardado con éxito.",
        type: "success",
        showCancelButton: false,
      });
      this.load();
    },
  },
});
